import { render, staticRenderFns } from "./vUpsellModal.vue?vue&type=template&id=306e38aa&scoped=true"
import script from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./vUpsellModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vUpsellModal.vue?vue&type=style&index=0&id=306e38aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306e38aa",
  null
  
)

export default component.exports